import React from "react";
import { useSelector } from "react-redux";

import { Col, Icon, Row } from "antd";
import { CardCustom, Title } from "./styles";
import ButtonStandard from "../../components/utils/button";

import { AnimalHandlingAlertContextProvider } from "../../contexts/animalHandlingAlertContext";
import useAnimalHandlingAlertContext from "../../hooks/useAnimalHandlingAlertContext";
import AnimalHandlingAlertTable from "./table";
import AnimalHandlingAlertForm from "./form";
import AnimalHandlingAlertDrawerEdit from "./drawerEdit";

const AnimalHandlingAlertLayout = () => {
  const { translation } = useSelector((state) => state.app);
  const { fetchData, openDrawer } = useAnimalHandlingAlertContext();

  return (
    <CardCustom>
      <Row className="rowHeader" justify="space-between">
        <Col span={8}>
          <Title>{translation.animalHandlingAlert.title}</Title>
        </Col>
        <Col span={16}>
          <Row type="flex" justify="end" gutter={8}>
            <Col>
              <ButtonStandard
                buttonType="typeWithoutBackground"
                onClick={fetchData}
              >
                <Icon type="reload" />
              </ButtonStandard>
            </Col>
            <Col>
              <ButtonStandard buttonType="addNew" onClick={() => openDrawer()}>
                {translation.animalHandlingAlert.buttonNew}
              </ButtonStandard>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row type="flex">
        <Col span={24}>
          <AnimalHandlingAlertTable />
        </Col>
      </Row>
    </CardCustom>
  );
};

const AnimalHandlingAlert = () => {
  return (
    <AnimalHandlingAlertContextProvider>
      <AnimalHandlingAlertLayout />
      <AnimalHandlingAlertForm />
      <AnimalHandlingAlertDrawerEdit />
    </AnimalHandlingAlertContextProvider>
  );
};

export default AnimalHandlingAlert;
